import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../common-service';
import { DeviceDetectorService } from 'ngx-device-detector';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit{
  sidebarVisibility:any
  isMobile:any
  hideSidebar: boolean = false;
  constructor(private commonservice:CommonService, private deviceService: DeviceDetectorService, private router: Router){
    this.isMobile = this.deviceService.isMobile();
  }
  ngOnInit(): void {
    this.hideSidebar = this.router.url.startsWith('/data-insight');

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hideSidebar = event.urlAfterRedirects.startsWith('/data-insight');
      }
    });

    if(this.isMobile){
      this.sidebarVisibility = false
    }
    else{
    this.commonservice.getshowhidesidebar.subscribe((data:any) => {
      this.sidebarVisibility = data
    })
    }
  }


}
